module.exports = __webpack_public_path__ + "static/media/home_seasonal_collection_btn.45840d46.png";